import GlobalLoading from '@/mixins/GlobalLoading'

export default {
  methods: {
    defaultRemoveLabels(app, className, resources) {
      this.openGlobalLoad()
      return Promise.resolve()
        .then(() => this.removeLabels(app, className, resources))
        .then(() => resources.forEach(i => i.label = null))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    removeLabels(app, className, resources) {
      const data = { resources: resources.map(r => ({ class_name: className, id: r.id })) }
      return this.axios.put('labels/bind_resources', data)
    }
  },
  mixins: [GlobalLoading],
  name: 'RemoveLabel'
}
